<script>
/* global axios */
import { mapGetters } from 'vuex';
import { getApiBaseUrl } from 'shared/helpers/env';
import SvgIcon from 'dashboard/components-next/SvgIcon/index.vue';

const SOLVED_CONVERSATIONS_TODAY_PATH =
  '/n/api/buyer/cs/aichat/agents/totalResolved';

export default {
  components: {
    SvgIcon,
  },
  props: {
    accountId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
    }),
    agentId() {
      return this.currentUser?.id;
    },
    tooltipText() {
      const displayCount = this.count ?? '--';
      return `Resolved Conversations Today: ${displayCount}`;
    },
    displayCount() {
      if (this.isLoading) return '...';
      return `${this.count ?? 0}`;
    },
  },
  data() {
    return {
      count: null,
      isLoading: false,
    };
  },
  mounted() {
    // Fetch count once on mount.
    this.fetchSolvedCount();
  },
  methods: {
    async fetchSolvedCount() {
      // Fetch solved conversations count for current agent today.
      if (!this.agentId) return;
      if (!this.accountId) return;

      const url = `${getApiBaseUrl()}${SOLVED_CONVERSATIONS_TODAY_PATH}`;

      this.isLoading = true;
      try {
        const response = await axios.get(url, {
          params: {
            accountId: this.accountId,
            agentId: this.agentId,
          },
        });
        // Expect: { data: { count: number } } (can be adjusted after API is confirmed)
        const nextCount = response?.data?.data?.resolvedCount;
        this.count = Number.isFinite(nextCount) ? nextCount : 0;
      } catch (error) {
        // Fail-safe: keep UI usable even if API fails.
        this.count = 0;
      } finally {
        this.isLoading = false;
      }
    },
    handleMouseEnter() {
      // Toggle to refresh icon state on hover.
      this.isHovering = true;
    },
    handleMouseLeave() {
      // Toggle back to default icon state on hover out.
      this.isHovering = false;
    },
    handleClick() {
      // Refresh solved count on click.
      this.fetchSolvedCount();
    },
    handleRefreshClick(event) {
      // Refresh solved count when clicking refresh icon.
      event?.stopPropagation?.();
      this.fetchSolvedCount();
    },
  },
};
</script>

<template>
  <div>
    <button
      v-tooltip.top="tooltipText"
      class="relative flex items-center justify-center w-10 h-10 p-0 my-2 rounded-lg text-[#60646C] dark:text-[#E0E1E6] hover:bg-slate-25 dark:hover:bg-slate-700"
      @click="handleClick"
    >
      <span
        class="min-w-[21px] border border-[#60646C] dark:border-[#E0E1E6] rounded-[3px] py-1 px-[1px] text-[10px] leading-none text-[#60646C] dark:text-[#E0E1E6] select-none"
      >
        {{ displayCount }}
      </span>

      <span
        class="absolute -top-0.5 -right-0.5 w-5 h-5 flex items-center justify-center rounded text-[#60646C] dark:text-[#E0E1E6]"
        role="button"
        tabindex="0"
        @click="handleRefreshClick"
      >
        <SvgIcon name="resolved_refresh" :size="12" className="dark:hidden" />
        <SvgIcon
          name="resolved_refresh_dark"
          :size="12"
          className="hidden dark:inline"
        />
      </span>
    </button>
  </div>
</template>

